import React from "react";
import PropTypes from "prop-types";
import Button from "../index";
import { ShoppingBag, Tag } from "react-feather";
import i18n from "~/assets/js/Helpers/i18n";
import { MenuPopup } from "~/assets/js/pages/ProductDetails/sections/MenuPopup/MenuPopup";
import MenuReminderPopup from "~/assets/js/pages/ProductDetails/sections/MenuPopup/MenuReminderPopup";
import { localstorage } from "~/assets/js/Helpers/localstorage";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import moment from "moment";

const QuantitySelectButton = ({
    min,
    max,
    quantity,
    onClick,
    showMenu = false,
    menuPopupOpen = false,
    setMenuPopupOpen = undefined,
    menuReminderPopupOpen = false,
    setMenuReminderPopupOpen = undefined,
    isLoading,
    onValueChange,
    customStyle,
}) => {
    const { get: getMenuLastDismissed, set: setMenuDismissed } =
        localstorage("menu-dismissed");

    const { isMobile } = useViewport();
    return (
        <>
            <div className="quantity-select-button">
                <input
                    name="quantity"
                    className={`quantity ${customStyle}`}
                    type="number"
                    min={min}
                    max={max}
                    value={quantity}
                    onChange={(e) => onValueChange(e.target.value)}
                />

                <Button
                    loading={isLoading}
                    loadingLabel=""
                    icon={<ShoppingBag />}
                    label={i18n.t("productInfo.addToCart")}
                    variant="primary"
                    size="SM"
                    customStyle={customStyle}
                    onClick={() =>
                        (!getMenuLastDismissed() ||
                            moment().isAfter(moment(getMenuLastDismissed()))) &&
                        showMenu
                            ? setMenuReminderPopupOpen(true)
                            : onClick()
                    }
                />
                {showMenu && (
                    <Button
                        loading={isLoading}
                        loadingLabel=""
                        icon={<Tag />}
                        label={isMobile ? "Menü" : "Spar-Menü"}
                        variant="primary"
                        size="SM"
                        customStyle={customStyle}
                        onClick={() => {
                            setMenuPopupOpen(true);
                        }}
                    />
                )}
            </div>
            {showMenu && (
                <>
                    <MenuPopup
                        isOpen={menuPopupOpen}
                        setOpen={setMenuPopupOpen}
                    />
                    <MenuReminderPopup
                        isOpen={menuReminderPopupOpen}
                        close={() => {
                            setMenuReminderPopupOpen(false);
                            setMenuDismissed(moment().add(18, "h").toDate());
                        }}
                        openMenuPopup={() => setMenuPopupOpen(true)}
                        submit={onClick}
                    />
                </>
            )}
        </>
    );
};

QuantitySelectButton.defaultProps = {
    min: 1,
    max: 100,
    isLoading: false,
};

QuantitySelectButton.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    quantity: PropTypes.number,
    onClick: PropTypes.func,
    isLoading: PropTypes.bool,
    onValueChange: PropTypes.func,
    customStyle: PropTypes.string,
};

export default QuantitySelectButton;
